<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header
          :title="title"
          :breadcrumbs="breadcrumbs"
          :back="true"
          :get-contacts="getContacts ?? []"
      >

      </app-sub-header>
      <!--end::Container-->
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">
        <!-- Header contact style Shop -->
        <div class="card mb-4">
          <div class="card-body py-4 px-6">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">

              <!-- Avatar + Nom + Infos -->
              <div class="d-flex align-items-center gap-3">
                <div class="symbol symbol-50px symbol-circle">
                  <img :src="contact.avatar_url" alt="avatar" style="width:50px;height:50px;border-radius:50%;object-fit:cover" />
                </div>
                <div>
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <span class="text-gray-900 fs-4 fw-bolder">{{ contact.fullname }}</span>
                    <span v-if="contact.contactType === 'society'" class="badge badge-light-info">
                      <i class="bi bi-building me-1"></i>{{ $t('contacts.contact_types.society') }}
                    </span>
                    <span v-else class="badge badge-light-primary">
                      <i class="bi bi-person me-1"></i>{{ $t('particular') }}
                    </span>
                    <span v-if="contact.customer" class="badge badge-light-success">{{ $t('contacts.customer') }}</span>
                    <span v-if="contact.supplier" class="badge badge-light-warning">{{ $t('contacts.supplier') }}</span>
                  </div>
                  <div class="d-flex flex-wrap gap-4 mt-1">
                    <span v-if="contact.email" class="text-gray-400 fs-7">
                      <i class="bi bi-envelope me-1"></i>{{ contact.email }}
                    </span>
                    <span v-if="getFirstPhone(contact.phone)" class="text-gray-400 fs-7">
                      <i class="bi bi-telephone me-1"></i>{{ getFirstPhone(contact.phone) }}
                    </span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <!-- Layout : menu gauche + contenu droite -->
        <div class="row g-5 mt-1">

          <!-- Menu vertical gauche -->
          <div class="col-lg-3 col-md-3">
            <div class="card card-flush">
              <div class="card-body p-3">
                <div class="menu menu-column menu-rounded menu-gray-600 menu-hover-bg menu-active-bg fw-semibold fs-6" @click="scrollToContent">

                  <div v-if="$can('customer_order_view')" class="menu-item mb-1">
                    <a class="menu-link px-3 py-2 rounded" style="cursor:pointer"
                      :class="activeTab === 'orders' ? 'active bg-light-primary text-primary' : ''"
                      @click="activeTab = 'orders'">
                      <span class="contact-menu-icon icon-success"><i class="bi bi-receipt"></i></span>
                      <span class="menu-title">{{ $t('contacts.achat') }}</span>
                    </a>
                  </div>

                  <div v-if="$can('customer_view')" class="menu-item mb-1">
                    <a class="menu-link px-3 py-2 rounded" style="cursor:pointer"
                      :class="activeTab === 'edit' ? 'active bg-light-primary text-primary' : ''"
                      @click="activeTab = 'edit'">
                      <span class="contact-menu-icon icon-primary"><i class="bi bi-person-lines-fill"></i></span>
                      <span class="menu-title">{{ $t('contacts.fiche_contact') }}</span>
                    </a>
                  </div>

                  <div v-if="$can('customer_address_view')" class="menu-item mb-1">
                    <a class="menu-link px-3 py-2 rounded" style="cursor:pointer"
                      :class="activeTab === 'address' ? 'active bg-light-primary text-primary' : ''"
                      @click="activeTab = 'address'">
                      <span class="contact-menu-icon icon-warning"><i class="bi bi-geo-alt"></i></span>
                      <span class="menu-title">{{ $t('contacts.address') }}</span>
                    </a>
                  </div>

                  <div v-if="$can('customer_view') && contact.supplier" class="menu-item mb-1">
                    <a class="menu-link px-3 py-2 rounded" style="cursor:pointer"
                      :class="activeTab === 'products' ? 'active bg-light-primary text-primary' : ''"
                      @click="activeTab = 'products'">
                      <span class="contact-menu-icon icon-dark"><i class="bi bi-box-seam"></i></span>
                      <span class="menu-title">{{ $t('contacts.products') }}</span>
                    </a>
                  </div>

                  <div v-if="$can('customer_view') && contact.supplier" class="menu-item mb-1">
                    <a class="menu-link px-3 py-2 rounded" style="cursor:pointer"
                      :class="activeTab === 'purchase' ? 'active bg-light-primary text-primary' : ''"
                      @click="activeTab = 'purchase'">
                      <span class="contact-menu-icon icon-info"><i class="bi bi-cart-check"></i></span>
                      <span class="menu-title">{{ $t('contacts.orders') }}</span>
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- Contenu droite -->
          <div ref="contactContent" class="col-lg-9 col-md-9 contact-content">

            <!-- Achats -->
            <div v-show="activeTab === 'orders'">

              <!-- KPI cards + date range sur la même ligne -->
              <div class="d-flex align-items-stretch gap-4 mb-5 flex-wrap">
                <div class="card border-0 shadow-sm flex-grow-1">
                  <div class="card-body py-4 px-5 d-flex align-items-center gap-3">
                    <div class="kpi-icon-wrap kpi-success">
                      <i class="bi bi-receipt fs-4"></i>
                    </div>
                    <div>
                      <div class="fs-2 fw-bolder text-gray-800">{{ orders_count || 0 }}</div>
                      <div class="fs-8 text-gray-400">{{ $t('contacts.total_achat') }}</div>
                    </div>
                  </div>
                </div>
                <div class="card border-0 shadow-sm flex-grow-1">
                  <div class="card-body py-4 px-5 d-flex align-items-center gap-3">
                    <div class="kpi-icon-wrap kpi-primary">
                      <i class="bi bi-currency-exchange fs-4"></i>
                    </div>
                    <div>
                      <div class="fs-4 fw-bolder text-gray-800">{{ $formatLocalAmount(orders_sum_amount_total) || '0' }} {{ currency }}</div>
                      <div class="fs-8 text-gray-400">{{ $t('contacts.turnover') }}</div>
                    </div>
                  </div>
                </div>
                <div class="card border-0 shadow-sm">
                  <div class="card-body py-4 px-5 d-flex align-items-center gap-3 h-100">
                    <div class="kpi-icon-wrap kpi-warning">
                      <i class="bi bi-calendar3 fs-4"></i>
                    </div>
                    <div stats-kt-daterangepicker="true" data-kt-daterangepicker-opens="left" style="cursor:pointer">
                      <div class="daterange_html text-gray-700 fw-bolder fs-7">Loading date range...</div>
                      <div class="fs-8 text-gray-400">{{ $t('contacts.date') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card card-min pt-4 mb-6 mb-xl-9">
                <div class="card-header border-0">
                  <div class="card-title">
                    <h2 class="fw-bolder mb-0">{{ $t('contacts.achat') }}</h2>
                  </div>
                </div>
                <div class="card-body">
                  <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_customer_order" style="margin-top: 13px !important; cursor:pointer">
                    <thead>
                      <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                        <th>{{ $t('contacts.order_number') }}</th>
                        <th>{{ $t('contacts.order_type') }}</th>
                        <th>{{ $t('contacts.shop') }}</th>
                        <th>{{ $t('contacts.total') }}</th>
                        <th>{{ $t('contacts.date') }}</th>
                        <th>{{$t("actions")}}</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>

            <!-- Fiche contact -->
            <div v-show="$can('customer_view') && activeTab === 'edit'">
                <!--begin::Card-->
                <div class="card mb-6 mb-xl-9">
                  <form @submit.prevent="updateContactData" class="form">

                  <div class="card-header border-0 pt-6">
                    <div class="card-title">
                      <h2 class="fw-bolder mb-0">{{ $t('contacts.fiche_contact') }}</h2>
                    </div>
                    <div class="card-toolbar">
                      <button v-if="$can('customer_update')" type="submit"  class="btn btn-sm btn-primary fw-bolder">
                        <span class="indicator-label">{{ $t('button.save') }}</span>
                      </button>
                    </div>
                  </div>

                  <div class="card-body pt-2">

                    <!-- Compte client Qomerxia : identité gérée par le client -->
                    <div v-if="identityLocked" class="alert alert-light-primary d-flex align-items-center gap-3 py-3 mb-6">
                      <span class="badge badge-primary">{{ $t('contacts.qomerxia_account') }}</span>
                      <span class="fs-7 text-gray-700">{{ $t('contacts.qomerxia_identity_locked') }}</span>
                    </div>

                    <!-- Avatar + type de contact -->
                    <div class="d-flex align-items-start gap-6 mb-6">
                      <div class="avatar-picker flex-shrink-0 mt-2 ms-2 me-2">
                        <div
                          class="avatar-picker-circle w-90px h-90px"
                          :style="{backgroundImage: 'url(' + avatarDisplayUrl +')'}"
                          @click="$refs.viewAvatarFileInput.click()"
                        >
                          <i class="bi bi-camera-fill avatar-picker-hint"></i>
                        </div>
                        <input ref="viewAvatarFileInput" v-on:change="onFileChange" type="file" name="avatar" accept=".png, .jpg, .jpeg" class="d-none" />
                        <span v-if="hasCustomAvatar" class="btn btn-icon avatar-action-icon avatar-action-remove" @click="removeFile" title="Remove avatar">
                          <i class="bi bi-x fs-8"></i>
                        </span>
                      </div>

                      <div class="flex-grow-1">
                        <div class="d-flex flex-wrap align-items-center gap-6">
                          <div class="form-check form-check-custom form-check-solid">
                            <input id="viewSociety" class="form-check-input" v-model="contactForm.contactType" value="society" required type="radio" :disabled="identityLocked" />
                            <label class="form-check-label fw-semibold" for="viewSociety">{{$t("contacts.detail.society")}}</label>
                          </div>
                          <div class="form-check form-check-custom form-check-solid">
                            <input id="viewParticular" class="form-check-input" v-model="contactForm.contactType" value="particular" required type="radio" :disabled="identityLocked" />
                            <label class="form-check-label fw-semibold" for="viewParticular">{{$t("contacts.detail.particular")}}</label>
                          </div>
                          <div class="vr d-none d-sm-block"></div>
                          <div class="form-check form-switch form-check-custom form-check-solid ms-3">
                            <input id="viewCustomer" class="form-check-input" v-model="contactForm.customer" type="checkbox" />
                            <label class="form-check-label" for="viewCustomer">{{$t("contacts.customer")}}</label>
                          </div>
                          <div class="form-check form-switch form-check-custom form-check-solid">
                            <input id="viewSupplier" class="form-check-input" v-model="contactForm.supplier" type="checkbox" />
                            <label class="form-check-label" for="viewSupplier">{{ $t('contacts.supplier') }}</label>
                          </div>
                        </div>

                        <div class="row g-4 mt-1">
                          <div class="col-md-4" v-if="contactForm.contactType === 'particular'">
                            <label class="required fs-7 fw-bold text-gray-700 mb-1">{{$t('user.gender')}}</label>
                            <input v-if="identityLocked" type="text" class="form-control form-control-solid" readonly
                                   :value="contactForm.gender === 'female' ? $t('user.female') : contactForm.gender === 'male' ? $t('user.male') : ''">
                            <select v-else required name="gender" class="form-select form-select-solid kt_select2"
                                    v-model="contactForm.gender"  data-control="select2"
                                    data-search="true"
                                    :data-placeholder="$t('user.civility')" >
                              <option value="female">{{ $t('user.female') }}</option>
                              <option value="male">{{ $t('user.male') }}</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <label class="required fs-7 fw-bold text-gray-700 mb-1">{{ $t("contacts.lastname") }}</label>
                            <input type="text" v-model="contactForm.lastname" class="form-control form-control-solid" required :readonly="identityLocked">
                          </div>
                          <div class="col-md-4" v-if="contactForm.contactType === 'particular'">
                            <label class="required fs-7 fw-bold text-gray-700 mb-1">{{ $t("contacts.firstname") }}</label>
                            <input type="text" v-model="contactForm.firstname" class="form-control form-control-solid" required :readonly="identityLocked">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="separator separator-dashed my-6"></div>

                    <!-- Coordonnées -->
                    <h6 class="fw-bold text-gray-800 mb-4">{{ $t('contacts.detail.contact_info') }}</h6>
                    <div class="row g-4">
                      <div class="col-md-4">
                        <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.phone")}}</label>
                        <InputTel
                          name="viewContactPhone"
                          containerClass=""
                          v-model:phone="contactForm.phone"
                          v-model:phoneCode="contactForm.phoneCode"
                          :placeholder="$t('contacts.phone')"
                          :isRequired="false"
                          :isDisabled="identityLocked"
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.email")}}</label>
                        <input type="email" class="form-control form-control-solid" v-model="contactForm.email" :readonly="identityLocked" />
                      </div>
                      <div class="col-md-4">
                        <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.website")}}</label>
                        <input type="url" :placeholder="$t('contacts.placeholder.website')" class="form-control form-control-solid" v-model="contactForm.website" />
                      </div>
                    </div>

                  </div>
                  </form>
                  <!--end::Card body-->
                </div>
                <!--end::Card-->
              </div>

            <!-- Produits fournisseur -->
            <div v-show="$can('customer_view') && contact.supplier && activeTab === 'products'">
              <div class="card card-min pt-4 mb-6 mb-xl-9">
                <div class="card-header border-0">
                  <div class="card-title">
                    <h2 class="fw-bolder mb-0">{{ $t('contacts.products') }}</h2>
                  </div>
                </div>
                <div class="card-body">
                  <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_supplier_products" style="margin-top: 13px !important; cursor:pointer">
                    <thead>
                      <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                        <th>{{ $t('product.name') }}</th>
                        <th>{{ $t('product.reference') }}</th>
                        <th>{{ $t('product.category') }}</th>
                        <th>{{ $t('product.online') }}</th>
                        <th>{{$t("actions")}}</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>

            <!-- Commandes fournisseur -->
            <div v-show="$can('customer_view') && contact.supplier && activeTab === 'purchase'">
              <div class="card card-min pt-4 mb-6 mb-xl-9">
                <div class="card-header border-0">
                  <div class="card-title">
                    <h2 class="fw-bolder mb-0">{{ $t('contacts.purchase_order') }}</h2>
                  </div>
                </div>
                <div class="card-body">
                  <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_customer_purchase_order" style="margin-top: 13px !important; cursor:pointer">
                    <thead>
                      <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                        <th>{{ $t('purchase.number') }}</th>
                        <th>{{ $t('contacts.order_created_date') }}</th>
                        <th>{{ $t('contacts.order_delivery_date') }}</th>
                        <th>{{ $t('contacts.order_status') }}</th>
                        <th>{{$t("actions")}}</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>

            <!-- Adresses -->
            <div v-if="$can('customer_address_view')" v-show="activeTab === 'address'">
                <!--begin::Card-->
                <div  v-if="empty_view">
                  <div class="card card-min pt-4 mb-6 mb-xl-9" v-if="contact.addresses && contact.addresses.length">
                    <!--begin::Card header-->
                    <div class="card-header border-0">
                      <!--begin::Card title-->
                      <div class="card-title">
                        <h2 class="fw-bolder mb-0">{{ $t('contacts.address') }}</h2>
                      </div>

                      <!--end::Card title-->
                      <!--begin::Card toolbar-->
                      <div class="card-toolbar">
                        <button v-if="$can('customer_address_create')" class="btn btn-sm btn-flex btn-light-primary" @click.prevent="openAddressModal('create')">
                          <!--begin::Svg Icon | path: icons/duotune/general/gen035.svg-->
                          <span class="svg-icon svg-icon-3">
																<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																	<rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
																	<rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor" />
																	<rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor" />
																</svg>
															</span>
                          <!--end::Svg Icon-->{{$t('contacts.add_new_address')}}</button>
                      </div>
                      <!--end::Card toolbar-->
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div id="kt_customer_view_payment_method" class="card-body pt-0">
                      <div  v-for="(address,key) in contact.addresses" :key="key">
                        <!--begin::Option-->
                        <div class="py-0" data-kt-customer-payment-method="row">
                          <!--begin::Header-->
                          <div class="py-3 d-flex flex-stack flex-wrap">
                            <!--begin::Toggle-->
                            <div class="d-flex align-items-center collapsible rotate" data-bs-toggle="collapse" :href="'#kt_customer_view_payment_method_' + key" role="button" aria-expanded="false" :aria-controls="'kt_customer_view_payment_method_' + key">
                              <!--begin::Arrow-->
                              <div class="me-3 rotate-90">
                                <!--begin::Svg Icon | path: icons/duotune/arrows/arr071.svg-->
                                <span class="svg-icon svg-icon-3">
																			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																				<path d="M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z" fill="currentColor" />
																			</svg>
																		</span>
                                <!--end::Svg Icon-->
                              </div>
                              <!--end::Arrow-->
                              <!--begin::Summary-->
                              <div class="me-3">
                                <div class="d-flex align-items-center">
                                  <div class="text-gray-800 fw-bolder">
                                    {{ address.address || address.city || address.quartier || address.zipcode || address.country || [address.lastname, address.firstname].filter(Boolean).join(' ') || '—' }}
                                  </div>
                                  <span v-if="address.default" class="btn btn-sm  btn-light-primary m-10" >{{ $t('contacts.default') }}</span>

                                </div>
                              </div>
                              <!--end::Summary-->
                            </div>
                            <!--end::Toggle-->
                            <!--begin::Toolbar-->
                            <div class="d-flex my-3 ms-9">
                              <!--begin::Edit-->
                              <button   v-if="$can('customer_address_update')" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" @click.prevent="openAddressModal('edit', address)">
                              <span data-bs-toggle="tooltip" data-bs-trigger="hover" :title="$t('button.edit')">
                                <!--begin::Svg Icon | path: icons/duotune/art/art005.svg-->
                                <i class="fa fa-edit"></i>
                                <!--end::Svg Icon-->
                              </span>
                              </button>
                              <!--end::Edit-->

                              <!--begin::More-->
                              <button v-if="$can('customer_address_update')"  v-show="!address.default" @click="contactSetDefaultAddress(address.id)" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="tooltip" :title="$t('contacts.set_default_adress')" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen019.svg-->
                                <span class="svg-icon svg-icon-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="currentColor" />
                                  <path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="currentColor" />
                                </svg>
                              </span>
                                <!--end::Svg Icon-->
                              </button>
                              <!--begin::Menu-->

                              <button v-if="$can('customer_address_delete')" @click="dropAddress(address.id)" class="btn btn-icon btn-active-light-primary w-30px h-30px" data-bs-toggle="tooltip" :title="$t('button.delete')" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen019.svg-->
                                <i class="fa fa-trash-alt"></i>
                                <!--end::Svg Icon-->
                              </button>

                              <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-150px py-3" data-kt-menu="true">
                                <!--begin::Menu item-->
                                <div class="menu-item px-3">
                                  <a href="#" class="menu-link px-3" data-kt-payment-mehtod-action="set_as_primary">Set as Primary</a>
                                </div>
                                <!--end::Menu item-->
                              </div>
                              <!--end::Menu-->
                              <!--end::More-->
                            </div>
                            <!--end::Toolbar-->
                          </div>
                          <!--end::Header-->
                          <!--begin::Body-->
                          <div :id="'kt_customer_view_payment_method_' + key" :class="key === 0 ? 'show' : ''" class="collapse  fs-6 ps-10" data-bs-parent="#kt_customer_view_payment_method">
                            <!--begin::Details-->
                            <div class="d-flex flex-wrap py-5">
                              <!--begin::Col-->
                              <div class="flex-equal me-5">
                                <table class="table table-flush fw-bold gy-1">
                                  <tr>
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.lastname') }}</td>
                                    <td class="text-gray-800">{{  address.lastname }}</td>
                                  </tr>
                                  <tr>
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.firstname') }}</td>
                                    <td class="text-gray-800">{{  address.firstname }}</td>
                                  </tr>
                                  <tr v-if="address.phone">
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.address_phone') }}</td>
                                    <td class="text-gray-800">
                                      {{ addressPhone(address) }}
                                      <span v-if="address.is_whatsapp" class="badge badge-light-success ms-2">WhatsApp</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.adress') }}</td>
                                    <td class="text-gray-800">{{  address.address }}</td>
                                  </tr>
                                  <tr v-if="address.point_de_repere">
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.address_landmark') }}</td>
                                    <td class="text-gray-800">{{ address.point_de_repere }}</td>
                                  </tr>

                                </table>
                              </div>
                              <!--end::Col-->
                              <!--begin::Col-->
                              <div class="flex-equal">
                                <table class="table table-flush fw-bold gy-1">
                                  <tr>
                                    <td class="text-muted min-w-125px w-125px">{{ $t('auth.country') }}</td>
                                    <td class="text-gray-800">{{ address.country }}</td>
                                  </tr>
                                  <tr>
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.placeholder.city') }}</td>
                                    <td class="text-gray-800">{{ address.city }}</td>
                                  </tr>
                                  <tr v-if="address.quartier">
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.address_quartier') }}</td>
                                    <td class="text-gray-800">{{ address.quartier }}</td>
                                  </tr>
                                  <tr v-if="address.location_label || (address.latitude && address.longitude)">
                                    <td class="text-muted min-w-125px w-125px">{{ $t('contacts.address_position') }}</td>
                                    <td class="text-gray-800">
                                      {{ address.location_label }}
                                      <a v-if="address.latitude && address.longitude" :href="addressMapUrl(address)" target="_blank" rel="noopener noreferrer" :class="address.location_label ? 'ms-2' : ''">{{ $t('contacts.address_view_on_map') }}</a>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <!--end::Col-->
                            </div>
                            <!--end::Details-->
                          </div>
                          <!--end::Body-->
                        </div>
                        <!--end::Option-->
                        <div v-if="key+1!==contact.addresses.length" class="separator separator-dashed"></div>
                      </div>

                    </div>
                    <!--end::Card body-->
                  </div>
                  <div v-else class="card card-min" >
                    <!--begin::Card body-->
                    <div class="card-body">
                      <!--begin::Heading-->
                      <div class="card-px text-center ">
                        <!--begin::Title-->
                        <h2 class="fs-2x fw-bolder mb-0">{{ $t('contacts.no_address_found') }}</h2>
                        <!--end::Title-->
                        <!--begin::Description-->
                        <p class="text-gray-400 fs-4 fw-bold py-7">{{ $t('button.clic') }}
                          <br /></p>
                        <!--end::Description-->
                        <!--begin::Action-->

                        <button v-if="$can('customer_address_create')"  @click.prevent="openAddressModal('create')" class="text-center btn btn-primary btn-sm">{{$t('contacts.add_new_address')}}</button>              <!--end::Action-->
                      </div>
                      <!--end::Heading-->
                      <!--begin::Illustration-->
                      <div class="text-center pt-8 ">
                        <img src="/assets/media/illustrations/sketchy-1/illustration1-custom.svg?v=2" alt="" class="mw-100 h-150px h-sm-125px" />
                      </div>
                      <!--end::Illustration-->
                    </div>
                    <!--end::Card body-->
                  </div>
                </div>
                <!--end::Card-->
              </div>

          </div>
          <!-- fin contenu droite -->

        </div>
        <!-- fin row layout -->
        <!--begin::Modals-->
        <!--begin::Modal - New Address-->

      </div>
      <!--end::Container-->
      <InvoicePdfModal ref="orderDetailModal" modal-id="orderDetailModal" />

      <TicketModal
        :sale="posTicketData"
        :currency="currency"
        :is-load="posTicketIsLoad"
        :is-loading="posTicketIsLoading"
        :symef-response="posTicketSymefResponse"
        @print="printPosTicket"
        @normalize="generatePosSymefInvoice"
      />

      <create-address
          v-if="contact.id"
          id="1"
          :get-countries="getCountries"
          :address="form"
          :action=action
          :contact=contact.id
          :contact_name=contact.name
          @addressCreated="contactAddressCreated"
          @addressUpdated="contactAddressUpdated"
      >
      </create-address>
    </div>
  </div>
</template>

<script>
import AppSubHeader from "@/views/Contact/partials/AppSubViewHeader";
import {BASE_IMAGE_URL, BASE_URL} from "@/services/api";
import {mapActions,mapGetters} from "vuex";
import CreateAddress from "@/components/CreateAddress";
import TicketModal from "@/components/TicketModal";
import InputTel from "@/components/InputTel.vue";
import InvoicePdfModal from "@/components/InvoicePdfModal";
import {Settings} from "luxon";
import {nextTick} from "vue";

export default {
  name: "View",
  components: {AppSubHeader, CreateAddress, TicketModal, InputTel, InvoicePdfModal},

  data(){
    return {
      title: 'breadcrumbs.contact.contacts',
      breadcrumbs :[
        {
          name : 'breadcrumbs.store.dashboard',
          path : '/admin/dashboard'
        },
        {
          name : 'breadcrumbs.contact.contacts',
          path : '/admin/contacts'
        },
        {
          name : 'breadcrumbs.contact.detail',
          path : ''
        },

      ],
      activeTab: 'orders',
      empty_view : false,
      orders_count : 0,
      orders_sum_amount_total : 0,
      contact : {},
      form : {
        id : null,
        gender : null,
        lastname: null,
        firstname: null,
        street: null,
        street2: null,
        city: null,
        zipcode: null,
        country: null
      },
      phones: [],
      contactForm : {
        id : null,
        gender : '',
        contactType: null,
        lastname: null,
        firstname: null,
        customer: true,
        birthday: null,
        supplier: false,
        phone: null,
        phoneCode: null,
        previewAvatar: BASE_IMAGE_URL +'/assets/blank.png',
        email:null,
        website: null
      },
      formDetailsData: {
        id: null,
        row: null,
        reference : '',
        customer :'',
        sub_total : 0,
        reduction : 0,
        shop_address : '',
        shop_phone : '',
        shop_name  : '',
        shop_country  : '',
        date  : '',
        operator : '',
        products: [],
        customer_detail:[]
      },
      detailInformation: [],
      startDate: null,
      endDate: null,
      action : 'create',
      currency: '',
      posTicketData: {
        id: null,
        reference: '',
        customer: '',
        sub_total: 0,
        total: 0,
        reduction: 0,
        shop_address: '',
        shop_phone: '',
        shop_name: '',
        shop_ifu_number: '',
        shop_rccm_number: '',
        operator: '',
        date: '',
        cash_change: 0,
        amountDonated: 0,
        products: [],
        acompte_amount: 0,
        acompte_remaining: 0,
        status: '',
        ifu_number: '',
        first_address_infos: '',
        phone: '',
        phone_code: '',
        customer_email: ''
      },
      posTicketCheckoutId: null,
      posTicketIsLoad: true,
      posTicketIsLoading: true,
      posTicketSymefResponse: {}
    }
  },
  watch: {
    '$i18n.locale': function(value){
      this.$nextTick(() =>   this.initDateRange())
      Settings.defaultLocale = value
      if(value && this.table){
        nextTick(() => {
          this.fetchDatas()
          this.fetchSupplierPurchaseOrders()
          this.fetchSupplierDeliveryProducts()
        })
      }
    },

    'startDate' : function(value){
      // Au montage, initDateRange() pose la date avant que le contact soit chargé :
      // loadContactData() lance alors lui-même les tableaux (sinon double
      // initialisation, et destroy() plantait sur un tableau en cours de chargement)
      if(this.startDate && this.contact.id){

        this.loadContactOrderData()
        this.destroyDataTable();
        this.fetchDatas()
        this.fetchSupplierPurchaseOrders()
        this.fetchSupplierDeliveryProducts()

      }
    },

    '$route.params.id' : function(value){
        if(value && this.$route.name == 'contact-view-path'){
              this.loadContactData()
          this.loadContactOrderData()

        }
    },
    'contactForm.contactType': function (value) {
      if (value) {
        this.$nextTick(() => {
          this.initSelect2()
          if(value && value == 'society') {
            this.contactForm.gender = ''
            this.contactForm.firstname = ''
          }
        })
      }
    },

  },
  async mounted(){

    this.$startLoadingPage()
    this.loadCities()
    this.loadCountries()
    this.loadContacts()
    this.initDateRange()

    KTImageInput.init();
    KTApp.initSelect2()
    this.initSelect2()

    await this.getGeneralInformation().finally(() =>  this.isReady = true )


    Settings.defaultLocale = localStorage.getItem('locale')

    let today = new Date() ;
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    $("#kt_hbd_view").flatpickr({
      dateFormat: "d-m-Y",
      maxDate: yesterday
    });

     await  this.loadContactData()
    // totaux de l'onglet Achats : la période est posée avant que le client soit chargé, donc
    // le suivi de la date ne les charge pas à l'arrivée sur la page — on le fait ici
    this.loadContactOrderData()
    this.empty_view = true
    await this.$nextTick()
    this.initDateRange()
     this.$endLoadingPage()

    $(document).on("click", "#kt_datatable_customer_order .order_view_btn", async (e) => {
      const btn = e.target.closest('.order_view_btn')
      const checkoutId = btn?.getAttribute('data-id')
      if (!checkoutId) return
      const source = btn.getAttribute('data-source')
      if (source === 'pos') {
        this.posTicketCheckoutId = checkoutId
        this.posTicketData.id = checkoutId
        this.posTicketData.reference = btn.getAttribute('data-ref')
        this.posTicketData.customer = btn.getAttribute('data-customer')
        this.posTicketData.sub_total = btn.getAttribute('data-sub-total')
        this.posTicketData.total = btn.getAttribute('data-total')
        this.posTicketData.reduction = btn.getAttribute('data-reduction')
        this.posTicketData.shop_address = btn.getAttribute('data-shop-address')
        this.posTicketData.shop_phone = btn.getAttribute('data-shop-phone')
        this.posTicketData.shop_name = btn.getAttribute('data-shop-name')
        this.posTicketData.shop_ifu_number = btn.getAttribute('data-shop-ifu')
        this.posTicketData.shop_rccm_number = btn.getAttribute('data-shop-rccm')
        this.posTicketData.operator = btn.getAttribute('data-operator')
        this.posTicketData.date = btn.getAttribute('data-date')
        this.posTicketData.cash_change = btn.getAttribute('data-cash-change')
        this.posTicketData.amountDonated = btn.getAttribute('data-amountDonated')
        this.posTicketData.products = JSON.parse(decodeURIComponent(btn.getAttribute('data-products')))
        this.posTicketData.acompte_amount = JSON.parse(btn.getAttribute('data-acompte-amount'))
        this.posTicketData.acompte_remaining = JSON.parse(btn.getAttribute('data-acompte-remaining'))
        this.posTicketData.status = btn.getAttribute('data-status')
        this.posTicketData.ifu_number = btn.getAttribute('data-ifu')
        this.posTicketData.phone = btn.getAttribute('data-phone')
        this.posTicketData.phone_code = btn.getAttribute('data-phone-code')
        this.posTicketData.customer_email = btn.getAttribute('data-customer-email')
        this.posTicketData.first_address_infos = btn.getAttribute('data-customer-address')
        this.posTicketSymefResponse = {}
        this.posTicketIsLoad = true
        this.posTicketIsLoading = true
        try {
          const response = await this.verifyInvoiceNormalization(checkoutId)
          this.posTicketSymefResponse = response.data
        } catch (err) {}
        this.posTicketIsLoad = false
        this.posTicketIsLoading = false
        return
      }
      this.$refs.orderDetailModal.open(checkoutId)
    });

    $(document).on("click", "#kt_datatable_customer_purchase_order .eye_btn_order", async (e) => {
        let id_order = e.target.getAttribute('data-id')
        if (id_order) {
          this.$router.push({ name: 'suppliers-purchases-view', params: { id: id_order } })
        }
    });

    $(document).on("click", "#kt_datatable_supplier_products .eye_btn_product", async (e) => {
        let id_product = e.target.getAttribute('data-id')
        if (id_product) {
          this.$router.push({ name: 'settings-items-view', query: { product: id_product } })
        }
    });

    this.getCurrency().then((response) => {
        this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native
    })

  },

  computed : {
    ...mapGetters('countries',[
      'getCountries'
    ]),
    ...mapGetters('contacts',[
      'getContacts'
    ]),
    ...mapGetters('cities', [
      'getCity'
    ]),

    // fiche liée à un compte client Qomerxia : civilité, nom, e-mail et téléphone gérés par le client
    identityLocked(){
      return !!(this.contact && (this.contact.qomerxia_account || this.contact.customer_account_id))
    },

    avatarDisplayUrl(){
      if (this.contactForm.previewAvatar instanceof File) {
        return URL.createObjectURL(this.contactForm.previewAvatar)
      }
      return this.contactForm.previewAvatar
    },

    hasCustomAvatar(){
      if (this.contactForm.previewAvatar instanceof File) return true
      const url = this.contactForm.previewAvatar || ''
      return !!url && !url.includes('img_default.jpg') && !url.includes('blank.png')
    },
  },
  methods : {
    // Sur mobile le menu est empilé au-dessus du contenu : après un clic on descend sur l'onglet choisi
    scrollToContent(e) {
      if (!e.target.closest('.menu-link') || window.innerWidth >= 768) return
      this.$nextTick(() => this.$refs.contactContent?.scrollIntoView({ behavior: 'smooth', block: 'start' }))
    },
    ...mapActions('cities', [
      'loadCities'
    ]),
    ...mapActions('contacts',[
      'loadContacts',
      'getContact',
      'deleteAddress',
      'updateContact',
      'uploadAvatar',
      'setDefaultAddress'
    ]),
    ...mapActions('countries',[
      'loadCountries'
    ]),
    ...mapActions('shop', ['getCurrency']),

    ...mapActions('shop', ['generalInformation']),

    ...mapActions('posCart', ['normalizationInvoice', 'verifyInvoiceNormalization']),

    async generatePosSymefInvoice() {
      this.posTicketIsLoading = true
      this.posTicketIsLoad = true
      try {
        const response = await this.normalizationInvoice(this.posTicketCheckoutId)
        this.posTicketSymefResponse = response.data
        window.toastr['success']("Facture Normalisée générer avec succès")
      } catch (err) {}
      this.posTicketIsLoad = false
      this.posTicketIsLoading = false
    },

    printPosTicket() {
      let prtHtml = document.getElementById('invoice');
      let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=400,height=600,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
          <title>Ticket</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body {
              font-family: 'Courier New', Courier, monospace;
              font-size: 12px;
              width: 80mm;
              padding: 5mm;
            }
            table { width: 100%; border-collapse: collapse; }
            td { padding: 2px 0; vertical-align: top; font-size: 12px; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .company-name { font-size: 16px; font-weight: bold; }
            .separator { text-align: center; color: #000; padding: 5px 0 !important; }
            .separator-light { border-bottom: 1px solid #eee; padding: 3px 0 !important; }
            .product-name-cell { width: 55%; }
            .product-price-cell { width: 45%; text-align: right; }
            .discount-text { font-size: 10px; font-style: italic; }
            .ifu-rccm-line { font-size: 9px !important; }
            .nowrap-unit { white-space: nowrap; }
            .payment-row td { color: #333; }
            .total-final-row td { font-size: 14px; font-weight: bold; padding-top: 5px !important; }
            .remaining-row td { font-weight: bold; }
            .qr-section { margin-top: 10px; padding: 8px; border: 1px solid #000; }
            .qr-table td { font-size: 10px; padding: 1px 0; }
            .qr-code { text-align: center; margin-top: 8px; }
            .receipt-footer { text-align: center; margin-top: 10px; }
            .thanks-text { font-weight: bold; text-transform: uppercase; letter-spacing: 1px; }
            @media print {
              body { width: 80mm; margin: 0; padding: 2mm; }
              @page { margin: 0; size: 80mm auto; }
            }
          </style>
        </head>
        <body>${prtHtml.innerHTML}</body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => { WinPrint.print(); }, 250);
    },

    getFirstPhone(phone) {
      try {
        const parsed = JSON.parse(phone);
        return Array.isArray(parsed) ? parsed[0]?.toString() : '';
      } catch (e) {
        // Si ce n’est pas du JSON, retourne la valeur brute
        return phone?.toString() || '';
      }
    },
      async getGeneralInformation() {
        let response = await this.generalInformation()
        this.informations = response.data
        this.detailInformation = response?.data?.infoGeneral.tenant_information
      },
      printButton() {
            let prtHtml = document.getElementById('invoice-content');
            let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=0,status=0');
            WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <link href="https://fonts.googleapis.com/css?family=Inconsolata&display=swap" rel="stylesheet" type="text/css">
                   <style>
                        body{
                          margin: 0 !important;
                          font-family: 'Inconsolata', monospace;
                        }

                        @media print {
                          body{
                            margin: 0 !important;
                            font-family: 'Inconsolata', monospace;
                          }

                          body * {
                            visibility: hidden;
                          }

                          #invoice, #invoice * {
                            visibility: visible;
                          }

                          #invoice {
                            margin: 0 !important;
                            position: absolute !important;
                            font-family: "Inconsolata",serif;
                            top: 0 !important;
                            left: 0 !important;
                          }

                          .pos-sale-ticket {
                            text-align: left;
                            width: 94% !important;
                            background-color: white;
                            font-size: 12px;
                            padding: 15px 15px 15px !important;
                            display: inline-block;
                            font-family: "Inconsolata",serif;
                            border: solid 1px rgb(220,220,220);
                            border-radius: 3px;
                            overflow: hidden;
                            font-weight: bold !important;
                          }

                          .pos-sale-ticket .emph {
                            font-size: 15px;
                            // margin: 5px;
                          }

                          .pos-center-align {
                            text-align: center;
                          }

                          .pos-sale-ticket table {
                            width: 100%;
                            table-layout: fixed;
                            border-width: 0;
                            border-style: initial;
                            border-color: initial;
                            border-image: initial;
                          }


                          .pos-sale-ticket table td {
                            overflow-wrap: break-word;
                            border-width: 0;
                            border-style: initial;
                            border-color: initial;
                            border-image: initial;
                          }

                          .qr-pos-right-align {
                              text-align: right;

                          }
                           .qr-text {
                              font-size: 12px!important;

                          }
                       .pos-right-align {
                          text-align: right;
                          float: right;
                          margin-right: 20px;

                        }

                        .pos-disc-font {
                          font-size: 16px;
                          font-style: italic;
                          font-weight :bold !important;
                        }



                      }

                    </style>
                </head>
                <body>
                    ${prtHtml.innerHTML}
                </body>
                </html>`);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
        },
    initSelect2() {
      $("body .kt_select2").select2()
      $('body select[data-control="select2"]').select2()

      $("body .kt_select2").change((e) => {
        switch (e.target.name) {
          case 'contact':
              this.$router.push('/admin/contact/' + e.target.value + '/view')
            break;
          case 'gender' :
            this.contactForm.gender = e.target.value
            break;
          default:
            break;
        }
      });

    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.contactForm.previewAvatar = files[0]
    },

    removeFile(e) {
      this.contactForm.previewAvatar = BASE_IMAGE_URL +'/assets/blank.png'
      this.contactForm.avatar = null
      if (this.$refs.viewAvatarFileInput) this.$refs.viewAvatarFileInput.value = ''
    },

    destroyDataTable() {
      ['#kt_datatable_customer_order', '#kt_datatable_supplier_products', '#kt_datatable_customer_purchase_order'].forEach((selector) => {
        if (!$.fn.dataTable.isDataTable(selector)) return
        try {
          $(selector).DataTable().destroy()
        } catch (e) {
          // tableau pas encore prêt : il sera recréé juste après (destroy: true)
        }
      })
    },
    async initDateRange() {
      this.isReady = false
      let element = document.querySelector('[stats-kt-daterangepicker="true"]');
      let start = moment().subtract(29, 'days');
      let end = moment();

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      if (!element) return

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'),i18n.global.t('lu'),i18n.global.t('ma'),i18n.global.t('me'),i18n.global.t('je'),i18n.global.t('ve'),i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'),  i18n.global.t('august'),  i18n.global.t('september'),  i18n.global.t('october'),  i18n.global.t('november'),  i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

        }
      }, this.cb);

      this.cb(start, end);

    },

    async cb(start, end) {
      let element = document.querySelector('[stats-kt-daterangepicker="true"]');
      let display = element?.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

    },

    async loadContactData(){
        this.$startLoadingPage()
        KTImageInput.init();
        await this.getContact(this.$route.params.id).then((res) => this.contact = res.data.contact)
        this.destroyDataTable();
        this.fetchDatas()
        this.fetchSupplierPurchaseOrders()
        this.fetchSupplierDeliveryProducts()

        this.contactForm = {
            id: this.contact.id,
            avatar: this.contact.avatar ?  this.contact.avatar : null,
            avatar_url: this.contact.avatar_url ? this.contact.avatar_url : null,
            gender: this.contact.gender ? this.contact.gender : null,
            lastname: this.contact.lastname,
            firstname: this.contact.firstname,
            birthday: this.contact.birth ? this.contact.birth : null,
            phone: this.getFirstPhone(this.contact.phone) || null,
            phoneCode: this.contact.phone_code ? '+' + String(this.contact.phone_code).replace('+', '') : null,
            email: this.contact.email ? this.contact.email : null,
            contactType: this.contact.contactType ,
            customer: this.contact.customer ,
            supplier: this.contact.supplier ,
            website: this.contact.website ? this.contact.website : null,
            previewAvatar: this.contact.avatar_url ?? ''
        }
        this.$endLoadingPage()
    },

    async updateContactData(){

      this.$startLoadingPage()

      let response = {}

      try{
        const phoneCode = this.contactForm.phoneCode ? String(this.contactForm.phoneCode).replace('+', '') : null
        let phone = this.contactForm.phone ? String(this.contactForm.phone).replace(/\D/g, '') : null
        if (phone && phoneCode && String(this.contactForm.phone).trim().startsWith('+') && phone.startsWith(phoneCode)) {
          phone = phone.slice(phoneCode.length)
        }
        const payload = {
          ...this.contactForm,
          phone: phone,
          phone_code: phone ? phoneCode : null,
          phones: phone ? [phone] : []
        }
        delete payload.avatar
        delete payload.avatar_url
        delete payload.previewAvatar
        response = await this.updateContact(payload)
        this.contact = response.data.contact

        if (this.contactForm.previewAvatar && this.contactForm.previewAvatar instanceof File) {
          let avatarData = new FormData()
          avatarData.append('avatar', this.contactForm.previewAvatar);
          avatarData.append('contact_id', this.contactForm.id);
          let avatarResponse = await this.uploadAvatar(avatarData)
          this.contact.avatar_url = avatarResponse.data.avatar
        }

        window.toastr['success'](i18n.global.t("notification.contact_updated"))
        this.$endLoadingPage()
        return true

      }catch(err){
          this.$endLoadingPage()

      }
    },

    // téléphone de l'adresse précédé de son indicatif
    addressPhone(address){
      const code = String(address.phone_code || '').replace(/\D/g, '')
      return (code ? '+' + code + ' ' : '') + address.phone
    },
    addressMapUrl(address){
      return 'https://www.google.com/maps?q=' + address.latitude + ',' + address.longitude
    },
    setAddressValue(address){
      this.form = {
        id : address?.id || null,
        gender : address?.gender || null,
        lastname: address?.lastname || null,
        firstname: address?.firstname || null,
        street: address?.address || null,
        street2:address?.addressComp || null,
        city: address?.city || null,
        zipcode: address?.zipcode || null,
        country: address?.country_id || null,
      }
    },

    openAddressModal(action, address = null){
      this.action = action
      this.setAddressValue(address)
      $('#contactAddressModal1').modal('toggle')
    },

    contactSetDefaultAddress(id){
      Swal.fire({
        text: i18n.global.t('contacts.set_default_adress'),
        icon: "success",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText:  i18n.global.t('swal.yes'),
        cancelButtonText:  i18n.global.t('swal.no'),
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-secondary"
        }
      }).then( async (result) => {
        if (result.value) {
          let response = await this.setDefaultAddress({
            contact: this.contact.id,
            address: id
          })

          window.toastr['success']('Adresse  par défaut définie  avec succès')
           this.getContact(this.$route.params.id).then((res) => this.contact = res.data.contact)

          this.$stopLoading('kt_submit_create_contact')
        }
      });

    },

    dropAddress(id){
      Swal.fire({
        title:  i18n.global.t('swal.address'),
        text:  i18n.global.t('swal.text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('swal.yes'),
        cancelButtonText: i18n.global.t('swal.no'),
      }).then( async (result) => {
        if (result.value) {
          let response = await this.deleteAddress({
            contact: this.contact.id,
            address: id
          })

          let defaut = response.data.default

          let addresses = this.contact.addresses || []
          addresses = addresses.filter(address => address.id !== id)

          if(defaut){
            addresses = addresses.map(address => {
              if(defaut === address.id){
                address.default = true
              }
              return address
            })
          }

          this.contact.addresses = addresses
        }
      });

    },

    async loadContactOrderData(){

      if( this.startDate && this.endDate){

        try {
          this.$startLoadingPage()
          let response = await axios.get('get/contact/' + this.$route.params.id + '/orders/stats' + `?startDate=${this.startDate}&endDate=${this.endDate}`)
          this.orders_sum_amount_total = response.data.orders_sum_amount_total
          this.orders_count = response.data.orders_count
            this.$endLoadingPage()
        } catch (error) {
        }
      }
    },

    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_customer_order").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 4, 'desc']],
        ajax: {
          url: BASE_URL + '/get/contact/' + this.$route.params.id + '/orders/datatables' + `?startDate=${this.startDate}&endDate=${this.endDate}`,
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },

        },
        columns: [{ data: "reference" },{ data: "source" },{ data: "shop_name" },{ data: "total" },{ data: "date" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -6,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -5,
            orderable: !1,
            render: (t, a, e, l) => {
              const isPos = t === 'pos'
              const badgeClass = isPos ? 'badge-light-success' : 'badge-light-primary'
              const label = isPos ? this.$t('dashboard.pos') : this.$t('dashboard.ecommerce')
              return '<span class="badge ' + badgeClass + '">' + label + '</span>'
            },
          },
          {
            targets: -4,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            render: (t, a, e, l)=> {
              let totalFormat = this.$formatLocalAmount(t) + ' ' + this.currency;
              return '<span class="nameRow'+ l.row +'">' + totalFormat + "</span>";
            },
          },
          {
            targets: -2,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              if (e.source === 'pos') {
                const encodedProducts = encodeURIComponent(JSON.stringify(e.products || []))
                return '<button type="button" data-bs-toggle="modal" data-bs-target="#kt_modal_1" data-id="' + e.id + '" data-source="pos"' +
                  ' data-ref="' + (e.reference ?? '') + '" data-customer="' + (e.customer ?? '') + '"' +
                  ' data-sub-total="' + (e.sub_total ?? 0) + '" data-total="' + (e.total ?? 0) + '"' +
                  ' data-reduction="' + (e.reduction ?? 0) + '" data-shop-address="' + (e.shop_address ?? '') + '"' +
                  ' data-shop-phone="' + (e.shop_phone ?? '') + '" data-shop-name="' + (e.shop_name ?? '') + '"' +
                  ' data-shop-ifu="' + (e.shop_ifu_number ?? '') + '" data-shop-rccm="' + (e.shop_rccm_number ?? '') + '"' +
                  ' data-operator="' + (e.operator ?? '') + '" data-date="' + (e.date ?? '') + '"' +
                  ' data-cash-change="' + (e.cash_change ?? 0) + '" data-amountDonated="' + (e.amountDonated ?? 0) + '"' +
                  ' data-acompte-amount="' + (e.acompte_amount ?? 0) + '" data-acompte-remaining="' + (e.acompte_remaining ?? 0) + '"' +
                  ' data-status="' + (e.status ?? '') + '" data-ifu="' + (e.ifu_number ?? '') + '" data-phone="' + (e.phone ?? '') + '" data-phone-code="' + (e.phone_code ?? '') + '"' +
                  ' data-customer-email="' + (e.customer_email ?? '') + '" data-customer-address="' + (e.first_address_infos ?? '') + '"' +
                  ' data-products="' + encodedProducts + '"' +
                  ' class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 order_view_btn">' +
                  '<i class="fa fa-eye"></i>' +
                  '</button>'
              }
              return '<button type="button" data-id="' + e.id + '" data-source="' + e.source + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 order_view_btn">' +
                '<i data-id="' + e.id + '" data-source="' + e.source + '" class="fa fa-eye order_view_btn"></i>' +
                '</button>'
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    fetchSupplierDeliveryProducts(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_supplier_products").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'asc']],
        ajax: {
          url: BASE_URL + '/supplier/' + this.$route.params.id + '/products/datatable' + `?startDate=${this.startDate}&endDate=${this.endDate}`,
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },

        },
        columns: [{ data: "name" },{ data: "reference" },{ data: "category_name" },{ data: "online" }, { data: "actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -5,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -4,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            render: (t, a, e, l)=> {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -2,
            render: function (t, a, e, l) {
              if(e.online === true) return '<span class="nameRow light-primary'+ l.row +'">En ligne</span>';
              else return '<span class="nameRow light-danger'+ l.row +'">Hors ligne</span>';
            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              return '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.product_id + '" class="btn btn-sm btn-clean btn-icon eye_btn_product"><i data-row="' + l.row + '" data-id="' + e.product_id + '" class="fa fa-eye fs-2"></i></a>'
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    fetchSupplierPurchaseOrders(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_customer_purchase_order").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'asc']],
        ajax: {
          url: BASE_URL + `/orders/datatables?supplier_id=${this.$route.params.id}&date=${this.startDate}&delivery_date=${this.endDate}`,
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },

        },
        columns: [{ data: "number" },{ data: "date" },{ data: "delivery_date" },{ data: "status" }, { data: "actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -5,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -4,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            render: (t, a, e, l)=> {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -2,
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              return '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon eye_btn_order"><i data-row="' + l.row + '" data-id="' + e.id + '" class="fa fa-eye fs-2"></i></a>'
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    contactAddressCreated(address){
      let addresses = this.contact.addresses || []
      addresses.push(address)
      this.contact.addresses = addresses
    },

    contactAddressUpdated(address){
      let addresses = this.contact.addresses || []
      addresses = addresses.map(addr => {
        if(addr.id === address.id){
          return address
        }
        if (address.default){
          addr.default = false
        }
        return addr
      })
      this.contact.addresses = addresses
    },

    pad(s) {
      return (s < 10) ? '0' + s : s;
    },

    convertDate(d) {
      return [d.getFullYear(), this.pad(d.getMonth()+1), this.pad(d.getDate()),].join('-')
    },

    timeZone(){
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },

  }

}
</script>

<style scoped>
/* laisse la place de l'en-tête fixe quand on défile vers le contenu (mobile) */
.contact-content {
  scroll-margin-top: 75px;
}

.card-min{
  height: auto!important;
}

.avatar-picker {
  position: relative;
  display: inline-block;
}

.avatar-picker-circle {
  border-radius: 10px;
  background-color: #f5f8fa;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px dashed #d9d9e3;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.avatar-picker-hint {
  color: #fff;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px;
}

.avatar-action-icon {
  padding: 0 !important;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  color: #fff !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));
}

.avatar-action-remove {
  position: absolute;
  top: -2px;
  right: -2px;
  cursor: pointer;
}
.avatar-action-remove i {
  color: #f1416c !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));
}

.contact-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  margin-right: 10px;
  font-size: 0.95rem;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
/* Icônes : une seule couleur (celle de la boutique), comme le menu principal ;
   les classes icon-* restent sur les entrées mais ne changent plus la couleur */
.contact-menu-icon.icon-primary,
.contact-menu-icon.icon-success,
.contact-menu-icon.icon-warning,
.contact-menu-icon.icon-danger,
.contact-menu-icon.icon-info,
.contact-menu-icon.icon-dark {
  background: rgba(var(--kt-primary-rgb), 0.12);
  color: var(--kt-primary);
}

/* le thème grise les <i> du menu : l'icône prend la couleur de son cadre */
.contact-menu-icon i {
  color: inherit !important;
}

.kpi-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
/* même couleur pour les trois icônes des chiffres clés */
.kpi-success,
.kpi-primary,
.kpi-warning { background: rgba(var(--kt-primary-rgb), 0.12); color: var(--kt-primary); }
.kpi-icon-wrap i { color: inherit !important; }

.light-danger {
    color: #f1416c;
    border-color: #fff5f8;
    background-color: #fff5f8;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}

.light-primary {
    color: #0b3d87;
    border-color: #f1faff;
    background-color: #f1faff;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}
</style>
